import { PlayIcon } from "@heroicons/react/24/outline";
import { useLocale } from "../i18n";
import { formatLocale } from "../formatLocale";

export function ResultStageCountdown({ remaining, running, published, title, onStart }: {
  remaining: number; running: boolean; published: boolean; title: string; onStart: () => void;
}) {
  const { w, lang } = useLocale();
  return <section className="stage-countdown" aria-label={w("العد التنازلي لعرض النتائج", "Result reveal countdown")}>
    <div className="stage-countdown-circle">
      <span className="stage-countdown-tag">{w("لحظة إعلان النتيجة", "The result reveal")}</span>
      <strong role="timer" aria-live="off" aria-label={w("الثواني المتبقية", "Seconds remaining")}>{remaining.toLocaleString(formatLocale(lang))}</strong>
      <p>{published ? w("ثوانٍ تفصلنا عن عرض النتائج المنشورة", "Seconds until the published results are revealed") : w("ثوانٍ تفصلنا عن عرض المعاينة الإدارية", "Seconds until the administrative preview is revealed")}</p>
    </div>
    <h2 dir="auto">{title}</h2>
    <p>{w("عرض اللقطة المحفوظة؛ لا يعيد احتساب النتيجة أو ينشرها.", "Displays the saved snapshot; it does not recompute or publish results.")}</p>
    <p className="stage-countdown-status" role="status">{running ? w("العد التنازلي جارٍ…", "Countdown in progress…") : w("اللقطة الكاملة جاهزة للعرض", "The complete snapshot is ready to present")}</p>
    <button className="stage-countdown-start" disabled={running} onClick={onStart}><PlayIcon aria-hidden="true" />{w("إطلاق العد التنازلي على المسرح", "Start stage countdown")}</button>
  </section>;
}
